import { render, staticRenderFns } from "./InsuranceCompanyTable.vue?vue&type=template&id=1ce97b99"
import script from "./InsuranceCompanyTable.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyTable.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCompanyTable.vue?vue&type=style&index=0&id=1ce97b99&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports